Base = App.loadClass('core::reports/BaseOutput')

class exports.NontableOutput extends Base
    constructor: (parent, dialog, width = 'auto') ->

        super(parent, dialog, width, [], [])
